import { Component, OnInit, OnDestroy } from '@angular/core';
import { ApiService } from 'src/app/common/api-service/api.service';
import { Router } from '@angular/router';
import { News } from 'src/app/common/models/100news.models';
import { Subscription } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-m-home',
  templateUrl: './m-home.component.html',
  styleUrls: ['./m-home.component.scss'],
})
export class MHomeComponent implements OnInit, OnDestroy {
  subscription: Subscription[] = [];

  public firstFocusNews: News;
  public focusNews: any[] = [];
  public firstAdmission: any;
  public admissions: any[] = [];
  public notifications: any[] = [];
  public albums: any[] = [];
  public focusNewsRight: any[] = [];
  public events: any[] = [];
  public banners: any[] = [];
  public bannersLink: any[] = [];
  public bannersMobile: any[] = [];
  public isMobile: boolean = false;
  text_link: string = '';

  footer = {
    id: '',
    siteid: '',
    title: '',
    keywords: '',
    description: '',
    col1: '',
    col2: '',
    col3: '',
    footer: '',
    banner: '',
    linkvideo: '',
    about: '',
    aboutMain: '',
    approved: '',
    lang: '',
  }

  //fanpage
  video: any

  /**
   * constructor
   * @param api
   */
  constructor(private api: ApiService,
    private router: Router, private sanitizer: DomSanitizer) {
  }

  /**
   * ngOnInit
   */
  ngOnInit() {
    // first load
    this.subscription.push(this.api.sendDataService.language$.subscribe(data => {
      // load data news
      this.loadDataNews();
      this.loadDataBanner();
      this.getFooterWithSite();
      this.isMobileDevice();
      this.loadDataBannerLink();
    }));

    // init models
    this.firstFocusNews = {
      typeid: '',
      siteid: '',
      title: '',
      url: '',
      postdate: '',
      changedate: '',
      summary: '',
      content: '',
      pathimage: '',
      author: '',
      approved: '',
      comment: '',
      lang: '',
      isfocus: '',
      isNew: '',
      view: ''
    };

    setTimeout(() => {
      // notification change language
      this.api.sendDataService.setDataLanguage('true');
    }, 100);
  }

  /**
   * ngOnDestroy
   */
  ngOnDestroy() {
    this.subscription.forEach(item => {
      item.unsubscribe();
    });
  }

  /**
   * load Data Banner
   */
  loadDataBanner() {
    // load data banner
    const param = {
      'siteid': 2,
      'lang': this.api.getLanguage()
    };
    this.subscription.push(this.api.excuteAllByWhat(param, '88').subscribe(result => {
      let data = result.data;
      if (result.status == true) {
        this.banners = data;
        this.banners.forEach((element, index) => {
          if (index == 0) {
            element.style = 'carousel-item active';
          } else {
            element.style = 'carousel-item';
          }
          if (element.pathimage.substr(0, 9) == '/uploads/') {
            element.pathimage = 'https://hce.edu.vn' + element.pathimage;
          } else {
            element.pathimage = element.pathimage;
          }
        });
      }
    }));
  }

  /**
   * loadDataNews
   */
  loadDataNews() {
    // reset data
    this.focusNews = [];
    this.firstAdmission = [];
    this.admissions = [];
    this.notifications = [];
    this.albums = [];

    // load data focusNews
    const param1 = {
      'siteid': 2,
      'lang': this.api.getLanguage(),
      'typeid': 733, // là tin tức
      'offset': 0,
      'limit': 4,
    };
    this.subscription.push(this.api.excuteAllByWhat(param1, '100').subscribe(result => {
      let data = result.data;
      if (result.status == true) {
        this.focusNews = data;
        this.focusNews.forEach(item => {
          if (item.pathimage.substr(0, 9) == '/uploads/') {
            item.pathimage = 'https://hce.edu.vn' + item.pathimage;
          } else {
            item.pathimage = item.pathimage;
          }
        })
      }
    }));

    // load data focusNewsRight
    const param5 = {
      'siteid': 2,
      'lang': this.api.getLanguage(),
      'typeid': 733, // là tin tức
      'offset': 4,
      'limit': 10,
    };
    this.subscription.push(this.api.excuteAllByWhat(param5, '100').subscribe(result => {
      let data = result.data;
      if (result.status == true) {
        data.forEach(element => {
          if (element.pathimage.substr(0, 9) == '/uploads/') {
            element.pathimage = 'https://hce.edu.vn' + element.pathimage;
          } else {
            element.pathimage = element.pathimage;
          }
        });
        this.focusNewsRight = data;
      }
    }));

    // load data event
    const param6 = {
      'siteid': 2,
      'lang': this.api.getLanguage(),
      'typeid': '739,740,741,742', // là sự kiện hoạt động
      'offset': 0,
      'limit': 3,
    };
    this.subscription.push(this.api.excuteAllByWhat(param6, '96').subscribe(result => {
      let data = result.data;
      if (result.status == true && data.length > 0) {
        this.events = data;
        this.events.forEach(item => {
          if (item.pathimage.substr(0, 9) == '/uploads/') {
            item.pathimage = 'https://hce.edu.vn' + item.pathimage;
          } else {
            item.pathimage = item.pathimage;
          }
        })
      } else {
        this.events = [];
      }
    }));
  }

  /**
   * on Link Change
   * @param event
   */
  onLinkChange(event) {
    // this.router.navigate([event.srcElement.value], {});
    window.open(event.srcElement.value, '_blank');
  }

  /**
   * on news Click
   * @param url
   */
  onNewsClick(firstFocusNews) {
    let formatTitle = this.api.cleanAccents(firstFocusNews.title).split(' ').join('-');
    let re = /\//gi;
    formatTitle = formatTitle.replace(re, '');
    const url = '/detail/news/' + formatTitle + '/' + firstFocusNews.id + '/' + firstFocusNews.typeid;
    this.router.navigate([url.toLowerCase()]);

    // notification to animation on menu component
    this.api.sendDataService.setDataSend('true');
  }

  /**
   * on news Click
   * @param url
   */
  onTitleClick(contents) {
    let formatTitle = this.api.cleanAccents(contents.title).split(' ').join('-');
    let re = /\//gi;
    formatTitle = formatTitle.replace(re, '');
    const url = '/detail/contents/' + formatTitle + '/' + contents.id + '/' + contents.typeid;
    this.router.navigate([url.toLowerCase()], { skipLocationChange: false });

    // notification to animation on menu component
    this.api.sendDataService.setDataSend('true');
  }


  /**
   * getFooterWithSite
   */
  getFooterWithSite() {
    // update view of news
    const param = {
      'siteid': 2,
      'lang': this.api.getLanguage()
    };

    this.subscription.push(this.api.excuteAllByWhat(param, '27').subscribe(result => {
      let data = result.data;
      if (result.status == true) {

        this.footer = data[0];
        this.video = this.sanitizer.bypassSecurityTrustHtml(this.footer.linkvideo);
        if (this.footer.about.search('&lt;p') >= 0) {
          this.footer.about = this.api.formatHtmlTag(this.footer.about);
        }
        this.text_link = data[0].text_link;
      } else {
        this.footer = null;
        this.text_link = null;
      }
    }));
  }

  /**
   * isMobileDevice
   */
  isMobileDevice() {
    var userAgent = navigator.userAgent;
    if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
      // true for mobile device
      this.isMobile = true;
    } else {
      // false for not mobile device
      this.isMobile = false;
    }
  };

  /**
   * loadDataBannerLink
   */
  loadDataBannerLink() {
    const param = {
      'siteid': 2,
      'lang': this.api.getLanguage()
    };
    this.subscription.push(this.api.excuteAllByWhat(param, '89').subscribe(result => {
      let data = result.data;
      if (result.status == true && data.length > 0) {
        data.forEach((element, index) => {
          if (index == 0) {
            element.style = 'carousel-item active';
          } else {
            element.style = 'carousel-item';
          }
          if (element.pathimage.substr(0, 9) == '/uploads/') {
            element.pathimage = 'https://hce.edu.vn' + element.pathimage;
          } else {
            element.pathimage = element.pathimage;
          }
        });
        if (this.isMobile) {
          this.bannersMobile = data;
        } else {
          let colSlide = [];
          let processList = [
            {
              rowSlide: [
                colSlide = [data[0], data[1], data[2], data[3]],
              ],
              active: true
            },
            {
              rowSlide: [
                colSlide = [data[4], data[5], data[6], data[7]],
              ],
              active: false
            }
          ];
          this.bannersLink = processList;
        }

      }
    }));
  }
}
